import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';

import { BaseService } from './base.service';
import { Destination } from '../../objects/destination';

@Injectable({
  providedIn: 'root'
})
export class DestinationPersistanceService
  extends BaseService {
  createInstance = (attributes: any) => attributes;

  set(destination: Destination | null): void {
    const destinationId = !isNil(destination?.id) ?
      destination.id.toString() :
      null;
    try {
      localStorage.setItem(`destination__${this.hostname}`, destinationId ?? '');
    } catch {
      console.error('No access to local storage granted, some of the widget functionalities will be limited.');
    }
  }

  get(): number | null {
    try {
      const destinationId = localStorage.getItem(`destination__${this.hostname}`);

      if(isNil(destinationId)) {
        return null;
      }

      const serializedId = +destinationId;

      if(isNaN(serializedId)) {
        return null;
      }

      return serializedId;
    } catch {
      return null;
    }
  }
}
